export default "__VITE_ASSET__Cl$S5utX__"